// Note: While the ikonWeb token set is marked as deprecated, ikonPass, which is ostensibly what AMP has been told to use, does not have the necessary font family transformations, among others. Until this is resolved, we will continue to use ikonWeb.
import designSystemTokens from '@alterra-mountain-company/alterra-design-system/tokens/ikonWeb'
import type { Theme } from '@emotion/react'
import border from './borders'
import { createDevices } from './devices'
import font from './fonts'
import layer from './layers'
import variables from './variables'

const legacyTheme = {
  border,
  font,
  layer,
  variables,
}
const theme: Theme = {
  ...designSystemTokens,
  device: createDevices(designSystemTokens.breakpoint),
  _legacy: legacyTheme,
}

export type Devices = keyof typeof theme.device
export type Fonts = keyof typeof font
export type Borders = keyof typeof border
export type Layers = keyof typeof layer
export type Variables = keyof typeof variables
export type LegacyTheme = typeof legacyTheme
export type DesignSystemTheme = typeof designSystemTokens & {
  device: ReturnType<typeof createDevices>
}

export type TextAlign =
  | 'center'
  | 'left'
  | 'right'
  | 'justify'
  | 'initial'
  | 'inherit'

export default theme
